import type { Box } from '../types';

function triggerDownload(
  content: string,
  filename: string,
  mimeType: string
): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function escapeCSV(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function exportBoxesAsCsv(boxes: Box[]): void {
  const headers = [
    'Box Number',
    'Box Type',
    'Status',
    'Containers',
    'Maximum Capacity',
    'Security Seal 1',
    'Security Seal 2',
    'Notes',
    'Created At'
  ];

  const rows = boxes.map((box) => [
    box.box_number,
    box.box_type?.name ?? '',
    box.status,
    String(box.registrations_count),
    String(box.box_type?.max_capacity ?? 0),
    box.security_seal_1 ?? '',
    box.security_seal_2 ?? '',
    box.notes ?? '',
    box.created_at
  ]);

  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCSV).join(','))
    .join('\n');

  const timestamp = new Date().toISOString().slice(0, 10);
  triggerDownload(csv, `boxes-${timestamp}.csv`, 'text/csv;charset=utf-8;');
}
